import styled from 'styled-components';

export const ItCheckSection = styled.section`
  background: #f9fbfd;
  padding: 80px 20px;
  text-align: center;
  scroll-margin-top: 80px;
`;

export const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

export const Title = styled.h2`
  font-size: 2rem;
  color: #1f365c;
  margin-bottom: 12px;
`;

export const Sub = styled.p`
  max-width: 760px;
  margin: 0 auto 36px;
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
`;

export const DocsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
  margin-bottom: 28px;
`;

export const DocCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DocIcon = styled.div`
  font-size: 42px;
  margin-bottom: 10px;
  line-height: 1;
`;

export const DocTitle = styled.h3`
  font-size: 1.1rem;
  color: #1f365c;
  margin-bottom: 10px;
`;

export const DocActions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const DocLink = styled.a`
  display: inline-block;
  border-radius: 50px;
  padding: 10px 18px;
  text-decoration: none;
  font-weight: 600;
  border: 2px solid #ff0080;
  color: #ff0080;
  transition: all .2s ease-in-out;

  &:hover {
    background: #ff0080;
    color: #fff;
  }
`;

export const CTAWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  justify-content: center;
`;
